 
 <!-- 物流详情-->
<template>
  <div class="page" v-cloak>
    <van-nav-bar left-arrow fixed title="物流详情" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>

    <!-- 顶部详情 -->
    <div class="header-b" v-for="(item, index) in shippingList" :key="index">
      <h3 class="header-tips">物流订单信息</h3>
      <div class="total-block">
        <div class="total-left">物流公司</div>
        <div class="total-right">{{ item.shipping_name }}</div>
      </div>
      <div class="total-block">
        <div class="total-left"><span class="copy-btn" data-clipboard-target="#copy">复制编号</span><span>物流单号</span></div>
        <div class="total-right" id="copy">{{ item.shipping_code }}</div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="center-step">
      <van-steps direction="vertical" active-icon="passed" active-color="#00A8C0" :active="0">
        <van-step v-for="(item, index) in list" :key="index">
          <h3 :class="index == 0 ? 'fc':''">{{item.areaName}} <van-tag type="primary">{{ item.status }}</van-tag></h3>
          <p :class="index == 0 ? 'fc':''">{{item.context}}</p>
          <p>{{item.time}}</p>
        </van-step>
      </van-steps>
      <!-- v-if="list.length < 1" -->
      <van-divider>暂无物流信息</van-divider>
    </div>
  </div>
</template>

<script type="text/babel">
import ClipboardJS from "clipboard";
export default {
  name: "order-express",
  components: {},
  props: {},
  data() {
    return {
      list: [
        // {
        //   time: "时间",
        //   context: "说明",
        //   ftime: "",
        //   areaCode: "",
        //   areaName: "区域",
        //   status: "状态",
        // },
      ],
      shippingList: [],
      aa: {},
      order_sn: this.$route.query.order_sn,
      shipping: JSON.parse(this.$route.query.shipping) || [],
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    this.copy();
    this.$toast.allowMultiple();
    if (this.shipping.length > 0) {
      console.log(this.shipping);
      this.getExpress();
    } else {
      this.$toast.fail("暂无快递信息~");

      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    }
  },
  methods: {
    // shunfeng
    // SF1417631101207
    // 141QG202303161304266416

    //
    getExpress() {
      let _this = this;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let param = {
        order_sn: this.order_sn,
        // order_sn: "141QG202303161304266416",
        shipcompany_code: this.shipping[0].shipcompany_code, //"shunfeng",
        shipping_code: this.shipping[0].shipping_code, // "SF1417631101207",
      };

      this.$post("/api/user_order_shipping", param, param).then((res) => {
        // console.log(res);
        this.$toast.clear(); //关闭弹窗
        if (res.data.code == 0) {
          this.list = res.data.data.data;
          this.shippingList = res.data.data.shipping;

          console.log(res.data.data, "订单快递");
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },

    // 复制快递单号
    copy() {
      let ClipboardJSObj = new ClipboardJS(".copy-btn"); //className中有copyEle的元素
      //定义复制成功回调
      ClipboardJSObj.on("success", function (e) {
        alert("复制成功");
        e.clearSelection();
      });
      //定义复制失败回调
      ClipboardJSObj.on("error", function (e) {
        // alert('复制失败')
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 60px 10px;
  background-color: #f9f9f9;
  .header-b {
    // height: 208px;
    width: 100%;
    background-color: #fff;
    padding: 10px 0;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    .header-tips {
      padding-left: 20px;
      font-size: 14px;
      color: #2a2e43;
      text-align: left;
      position: relative;
    }
    .header-tips::after {
      content: "";
      position: absolute;
      width: 3px;
      height: 13px;
      left: 0;
      top: 2px;
      background: #00a8c0;
      z-index: 1;
      border-radius: 0 10px 10px 0;
    }
    .total-block {
      padding: 5px 10px;
      margin: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .total-left {
      width: 45%;
      text-align: right;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #454f63;
      .copy-btn {
        display: inline-block;
        margin-right: 10px;
        font-size: 10px;
        color: #e95970;
        transform: scale(0.8);
        -webkit-transform: scale(0.8);
        -moz-transform: scale(0.8);
      }
    }

    .total-right {
      width: 45%;
      text-align: right;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #78849e;
    }
  }
  //
  .center-step {
    background-color: #fff;
    margin: 25px 0;
    padding: 10px;
    text-align: left;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    color: #999999;
    h3 {
      font-size: 15px;
      font-family: Source Han Sans CN;
      // font-weight: 500;
      line-height: 26px;

      letter-spacing: 1px;
    }
    .fc {
      color: #2a2e43;
    }
    p {
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #999999;
      letter-spacing: 2px;
    }
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>

 